import React, { useEffect } from 'react'
import { AppProvider } from "./Appcontext";
import { useState } from "react";
import { useApp } from "./Appcontext";
import logo from '../../images/tiutLogo.png';
import df from '../../images/Default_pfp.jpg';
import { Link, Links, useOutletContext } from "react-router-dom";
import moment from 'moment';
function Header() {
      const { Leftmenu, setLeftmenu } = useApp();
      const { Rightmenut, setRightmenu } = useApp();
      const {search, setSearch} = useApp();
      const {user, token} = useOutletContext();
      const [notifications, setNotifications] = useState([]);

                  const getNotifications = () => {
                      fetch('/api/get-home-notifications',{
                          method: "POST",
                          headers: {
                              Authorization: `Bearer ${token}`,
                          },
                      }).then((response) => response.json())
                      .then((data) => {
                          if (data.extraerror) {
                              console.log(data.extraerror);
                          }
                          else if(data.data && data.message) {
                             
                              setNotifications(data.data);
                     
                             
                          }
                      })
                  }
        useEffect(() => {
            getNotifications();
        },[]);
  return (
    <div>   <div className="nav-header bg-white shadow-xs border-0">
            <div className="nav-top">
                <a href="/"><img src={logo} className="logo" alt="logo" style={{width:"150px"}} /> </a>
                <span   className="mob-menu ms-auto me-2 chat-active-btn" onClick={() => setRightmenu(!Rightmenut)} ><i className="feather-users text-grey-900 font-sm btn-round-md bg-greylight"></i></span>
                {/* <a  className="me-2 menu-search-icon mob-menu" onClick={() => setSearch(!search)}><i className="feather-search text-grey-900 font-sm btn-round-md bg-greylight"></i></a> */}
                <button className={Leftmenu ? "nav-menu me-0 ms-2 active" : "nav-menu me-0 ms-2"} onClick={() => setLeftmenu(!Leftmenu)}></button>
            </div>
            
            {/* <form action="#" className="float-left header-search">
                <div className="form-group mb-0 icon-input">
                    <i className="feather-search font-sm text-grey-400"></i>
                    <input type="text" placeholder="Start typing to search.." className="bg-grey border-0 lh-32 pt-2 pb-2 ps-5 pe-3 font-xssss fw-500 rounded-xl w350 theme-dark-bg" />
                </div>
            </form> */}
           
            <a href="#" className="p-2 text-center ms-auto menu-icon" id="dropdownMenu3" data-bs-toggle="dropdown" aria-expanded="false"><span className="dot-count bg-warning"></span><i className="feather-bell font-xl text-current"></i></a>
            <div className="dropdown-menu dropdown-menu-end p-4 rounded-3 border-0 shadow-lg" aria-labelledby="dropdownMenu3">
                
                <h4 className="fw-700 font-xss mb-4">Notification</h4>
                {notifications.length > 0 ? (
                  <div className="notifications">
                    {notifications.map((notification) => (
                        <Link to={notification.sender?.id ? `/profile/${notification.sender.id}` : "#"} key={notification.id}>
                      <div className="card bg-transparent-card w-100 border-0 ps-5 mb-3">
                        <img src={notification.sender?.personal_details?.profile_picture || df} alt="user" className="w40 position-absolute left-0 border-3 border-white rounded-circle" style={{aspectRatio: '1/1', objectFit: 'cover', objectPosition: 'center'}} />
                        <h5 className="font-xsss text-grey-900 mb-1 mt-0 fw-700 d-block">{notification.sender?.name || "System"} <span className="text-grey-400 font-xsssss fw-600 float-right mt-1">{moment(notification.created_at).fromNow()}</span></h5>
                        <h6 className="text-grey-500 fw-500 font-xssss lh-4">{notification.message}</h6>
                      </div>
                      </Link>
                    ))}
                  </div>
                ) : <h4 className="fw-700 font-xss mb-4">No Notification</h4>}
            
              
               
              
            </div>
            <a   className="p-2 text-center ms-3 menu-icon chat-active-btn" onClick={() => setRightmenu(!Rightmenut)}><i className="feather-users font-xl text-current"></i></a>
         
            

            
        </div>
        

         {/* <div className={search ? "app-header-search show" : "app-header-search"}>
            <form className="search-form">
                <div className="form-group searchbox mb-0 border-0 p-1">
                    <input type="text" className="form-control border-0" placeholder="Search..." />
                    <i className="input-icon">
                        <ion-icon name="search-outline" role="img" className="md hydrated" aria-label="search outline"></ion-icon>
                    </i>
                    <a href="#" className="ms-1 mt-1 d-inline-block close searchbox-close" onClick={() => setSearch(!search)}>
                        <i className="ti-close font-xs"></i>
                    </a>
                </div>
            </form>
        </div> */}
        
        </div>
  )
}

export default Header